export const getShareData = () => {
  if (typeof window === 'undefined') return null;

  const urlObj = new URL(window.location.href);
  urlObj.searchParams.set('utm_source', 'chat');
  urlObj.searchParams.set('utm_medium', 'share');

  return {
    url: urlObj.toString(),
  };
};
